import { Language, RegionAbbr } from '@novakid/ts-types';
import { SEARCH_PARAMS } from '@novakid/frontend-core';

export const CREDENTIAL_PARAMS = Object.freeze({
  LEGACY_USER_ID: SEARCH_PARAMS.LEGACY_USER_ID,
  AUTH_TOKEN: SEARCH_PARAMS.AUTH_TOKEN,
  AUTOLOGIN: SEARCH_PARAMS.AUTOLOGIN,
  USER_ID: SEARCH_PARAMS.USER_ID,
  HASH: SEARCH_PARAMS.HASH,
});

const PATH_KEYS = Object.freeze({
  ANONYMOUS_EXERCISES: 'anonymous-exercises',
  CLASSROOM_UNIFIED: 'classroom-unified',
  GROUP_CLASSROOM: 'group-classroom',
  SELECT_ACCOUNT: 'select-account',
  NEW_CLASSROOM: 'new-classroom',
  OLD_CLASSROOM: 'classroom',
  STUDENT: 'student',
  TEACHER: 'teacher',
  PARENT: 'parent',
  SIGNIN: 'signin',
  TUTOR: 'tutor',
});

export const ROUTES = Object.freeze({
  ANONYMOUS_EXERCISES: `/${PATH_KEYS.ANONYMOUS_EXERCISES}`,
  OLD_CLASSROOM_PLAYER: `/${PATH_KEYS.OLD_CLASSROOM}/view`,
  CLASSROOM_PLAYER: `/${PATH_KEYS.NEW_CLASSROOM}/view/:classId`,
  CLASSROOM_UNIFIED_PLAYER: `/${PATH_KEYS.CLASSROOM_UNIFIED}/:classId/view`,
  CLASSROOM_UNIFIED: `/${PATH_KEYS.CLASSROOM_UNIFIED}`,
  GROUP_CLASSROOM: `/${PATH_KEYS.GROUP_CLASSROOM}`,
  SELECT_ACCOUNT: `/${PATH_KEYS.SELECT_ACCOUNT}`,
  NEW_CLASSROOM: `/${PATH_KEYS.NEW_CLASSROOM}`,
  OLD_CLASSROOM: `/${PATH_KEYS.OLD_CLASSROOM}`,
  STUDENT: `/${PATH_KEYS.STUDENT}`,
  TEACHER: `/${PATH_KEYS.TEACHER}`,
  PARENT: `/${PATH_KEYS.PARENT}`,
  SIGNIN: `/${PATH_KEYS.SIGNIN}`,
  TUTOR: `/${PATH_KEYS.TUTOR}`,
});

// Special routes are routes for pages without standard user auth flow
export const SPECIAL_PAGES = [
  ROUTES.ANONYMOUS_EXERCISES,
  ROUTES.CLASSROOM_PLAYER,
  ROUTES.OLD_CLASSROOM_PLAYER,
  ROUTES.CLASSROOM_UNIFIED_PLAYER,
];

export type RegionalDomain =
  | 'school.novakid.pl'
  | 'school.novakid.de'
  | 'school.novakid.it'
  | 'school.novakid.es'
  | 'school.novakid.ru'
  | 'school.novakid.com.tr'
  | 'school.novakid.net.cn';

export const REGIONAL_DOMAINS_PARAMS: Record<
  RegionalDomain,
  { language: Language; region: RegionAbbr }
> = {
  'school.novakid.pl': { language: 'pl', region: 'PL' },
  'school.novakid.de': { language: 'de', region: 'DE' },
  'school.novakid.it': { language: 'it', region: 'IT' },
  'school.novakid.es': { language: 'es', region: 'ES' },
  'school.novakid.ru': { language: 'ru', region: 'RU' },
  'school.novakid.com.tr': { language: 'tr', region: 'TR' },
  'school.novakid.net.cn': { language: 'zh-CN', region: 'CN' },
};
